export default "__VITE_ASSET__D9UW1dSy__"